import { request } from 'api/http';
import qs from 'query-string';
import { SOCIAL_SHARE_STATS_URL } from './constants';
import {
  GetRequestStatusArgs,
  GetRequestStatusResponse,
  SocialShareStatsResponse,
  SocialShareStatsArgs,
  PodcastSocialStatsResponse,
  AllPodcastsSocialStatsArgs,
  PodcastSocialStatsArgs,
  AllPodcastsSocialStatsResponse,
} from './types';

export async function getSocialShareStats(args?: SocialShareStatsArgs) {
  const { data } = await request.get<SocialShareStatsResponse>(
    SOCIAL_SHARE_STATS_URL,
    {
      params: {
        episodeId: args?.episodeId,
      },
    },
  );
  return data;
}

export async function getAllPodcastsSocialShareStats(
  args?: AllPodcastsSocialStatsArgs,
) {
  const params = {
    platform: args?.platform,
  };

  const { data } = await request.get<AllPodcastsSocialStatsResponse>(
    `${SOCIAL_SHARE_STATS_URL}/podcasts`,
    {
      params,
      paramsSerializer: () => qs.stringify(params, { arrayFormat: undefined }),
    },
  );

  return data;
}

export async function getPodcastSocialShareStats(args: PodcastSocialStatsArgs) {
  const params = {
    platform: args.platform,
  };
  const { data } = await request.get<PodcastSocialStatsResponse>(
    `${SOCIAL_SHARE_STATS_URL}/podcasts/${args.podcastId}`,
    {
      params,
      paramsSerializer: () => qs.stringify(params, { arrayFormat: undefined }),
    },
  );

  return data;
}

export async function getSocialShareStatsRequestInfo(
  args: GetRequestStatusArgs,
) {
  const { data } = await request.get<GetRequestStatusResponse>(
    `${SOCIAL_SHARE_STATS_URL}/request/${args.requestId}`,
  );

  return data;
}

export async function requestSocialShareStats() {
  const { data } = await request.post<GetRequestStatusResponse>(
    `${SOCIAL_SHARE_STATS_URL}/request`,
  );

  return data;
}
